// Copyright (c) 2021 Deere & Company

import {
    filterCollection,
    sortCollection
} from '../../../shared/services/collections';
import actions from '../actions-list';
import filterOptions from '../constants/filter-options';

export const updateListFilterBy = (masslaborraterequest, filterBy) =>
    dispatch => {

        dispatch({
            data: filterCollection(filterBy, filterOptions, masslaborraterequest),
            type: actions.UPDATE_MASS_LABOR_RATE_REQUEST_FILTERED
        });

        dispatch({
            filterBy,
            type: actions.UPDATE_MASS_LABOR_RATE_REQUEST_FILTER_BY
        });

    };

export const updateListSortBy = (dealers, sortBy, sortDirection) =>
    dispatch => {

        dispatch({
            data: sortCollection(sortBy, sortDirection, dealers),
            type: actions.UPDATE_MASS_LABOR_RATE_REQUEST_FILTERED
        });

        dispatch({
            sortBy,
            type: actions.UPDATE_MASS_LABOR_RATE_REQUEST_SORT_BY
        });

    };

export const updateListSortDirection = (dealers, sortBy, sortDirection) =>
    dispatch => {

        dispatch({
            data: sortCollection(sortBy, sortDirection, dealers),
            type: actions.UPDATE_MASS_LABOR_RATE_REQUEST_FILTERED
        });

        dispatch({
            sortDirection,
            type: actions.UPDATE_MASS_LABOR_RATE_REQUEST_SORT_DIRECTION
        });

    };



// WEBPACK FOOTER //
// ./src/claim/mass-labor-rate-request-status-details/action-creators/search-filters.js